<div class="container-fluid">
    <div class="row">
        <div class="col-12 pt-2 pb-2 d-flex"
            style="align-items: end; justify-content: center;">
            <div class="col-12 col-md-10 desc d-flex"
                style="justify-content: end;">
                {{ "©" }}{{currentYear}}
                {{ " Aivoria. All rights reserved." | translate }}
            </div>
        </div>
    </div>
</div>